import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/fonts.css';
// Side-effect import: initializes Firebase (app/database/auth) and
// analytics. `app` itself is intentionally unused — importing the module is
// the point, so every consumer of getDatabase()/getAuth() gets an
// initialized default app.
import './config/firebase';
import './config/i18n';
import { LanguageProvider } from './context/LanguageContext';
import ErrorBoundary from './components/ErrorBoundary';

try {
  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Failed to find the root element');
  }
  const root = createRoot(container);
  // ErrorBoundary must wrap the app at the root: the try/catch below cannot
  // catch render errors (they happen inside React's own render cycle).
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
} catch (error) {
  // Only covers bootstrap failures (e.g. missing #root element).
  console.error('Application failed to start:', error);
}
